import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FamiliesComponent } from './families.component';

import { AuthGuard } from '../guards/auth.guard';
import { MatButtonModule} from '@angular/material/button';
import { VarModule } from '../directives/ngVar';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { FamilyListFilterModule } from '../components/family-list-filter/family-list-filter.module';
import { EditFamilyDialogModule } from '../components/edit-family-dialog/edit-family-dialog.module';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';



@NgModule({
  imports: [
    CommonModule,
    EditFamilyDialogModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSortModule,
    MatTooltipModule,
    FamilyListFilterModule,
    ReactiveFormsModule,
    VarModule,
    RouterModule.forChild([
      {
        path: 'families',
        canActivate: [AuthGuard],
        component: FamiliesComponent,
        children: []
      }
    ])
  ],
  declarations: [
    FamiliesComponent
  ],
  exports: [
    FamiliesComponent
  ]
})
export class FamiliesModule { }
